import { IconButton, Typography } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import MinusIcon from '@material-ui/icons/Remove'

import useStyles from './styles/counterWithLabel.styles'

export interface CounterProps {
  label?: string
  value: number
  setValue: (val: number) => void
  min?: number
  max?: number
}

export const CounterWithLabel: React.FC<CounterProps> = ({
  label,
  value,
  setValue,
  min,
  max
}) => {
  const classes = useStyles()
  const increase = () => {
    if (max) {
      if (value < max) {
        setValue(value + 1)
      }
    } else {
      setValue(value + 1)
    }
  }

  const decrease = () => {
    if (min) {
      if (value > min) {
        setValue(value - 1)
      }
    } else {
      setValue(value - 1)
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.textContainer}>
        <Typography className={classes.label}>{label}</Typography>
      </div>
      <div className={classes.Counter}>
        <IconButton
          data-testid="decrease"
          onClick={() => decrease()}
          className={classes.button}
          size="small">
          <MinusIcon />
        </IconButton>
        <Typography
          className={classes.countValue}
          color="primary"
          data-testid="value">
          {value}
        </Typography>
        <IconButton
          data-testid="increase"
          onClick={() => increase()}
          className={classes.button}
          size="small">
          <AddIcon />
        </IconButton>
      </div>
    </div>
  )
}
